import { Nuevas_normas } from '../../../models/nuevas_normas.model';
import { Component } from "@angular/core";
import * as moment from 'moment'
import { FormControl, FormGroup, Validators} from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDatepickerInputEvent } from '@angular/material';



@Component({
    selector: "page-nuevas_normas",
    templateUrl: "./nuevas_normas.component.html", 
    providers: [FormService]
})

export class Nuevas_normasComponent {
    
    public rows = [];
      public actualRow;
      public nuevas_normas: Nuevas_normas;
      public form;
      
      matcher = new FormService();
      

    constructor( public _formService: FormService){

        this.form = new FormGroup({
            nuevas_normas: new FormControl(''),
        })

        if(!JSON.parse(localStorage.getItem("nuevas_normas"))){
            localStorage.setItem("nuevas_normas", JSON.stringify(this.rows));
        }else{
            
            this.rows = JSON.parse(localStorage.getItem("nuevas_normas"));

            this.form.controls['nuevas_normas'].setValue(this.rows[0]?this.rows[0].nuevas_normas:'')
            
            
        }

        
        

    }


    add_nuevas_normas( ){


            
        localStorage.setItem("nuevas_normas",JSON.stringify([]));
        this.actualRow = localStorage.getItem("nuevas_normas");
        this.rows = JSON.parse(this.actualRow);
        this.rows = this.rows.concat({
            nuevas_normas: this.form.value.nuevas_normas,
        })

        localStorage.setItem("nuevas_normas", JSON.stringify(this.rows));
        //this.form.reset();

        //this.cip = JSON.parse(localStorage.getItem("cip"));

    }
    delete_nuevas_normas(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("nuevas_normas", JSON.stringify(this.rows));
            }
        }
    }
}